import { Group, Stack, Text, Title } from '@mantine/core'
import Message from '../../i18n/Message'

export default function PageHeader({ title, subtitle, actions }) {
  return (
    <Group justify="space-between" align="flex-start" mb="lg" wrap="wrap">
      <Stack gap={2}>
        <Title order={2}>
          <Message id={title} />
        </Title>
        {subtitle && (
          <Text c="dimmed" size="sm">
            {typeof subtitle === 'string' && !subtitle.includes(' ') && subtitle.includes('_') ? <Message id={subtitle} /> : subtitle}
          </Text>
        )}
      </Stack>
      {actions && <Group gap="sm">{actions}</Group>}
    </Group>
  )
}
